import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Layout from '../../components/Layout';
import MainSection from './MainSection';
import PostContentSection from './PostContentSection';
import LikePosts from './LikePosts';
import SEO from '../../components/Seo';

const formatPost = (post) => ({
  html: post.html,
  date: post.frontmatter.date,
  update_date: post.frontmatter.update_date,
  title: post.frontmatter.title,
  description: post.frontmatter.description || post.excerpt,
  title_post: post.frontmatter.title_post,
  cover: post.frontmatter.featured_image.childImageSharp.gatsbyImageData,
  category: post.frontmatter.categories[0],
});

const formatPosts = ({ node }) => ({
  slug: node.fields.slug,
  date: node.frontmatter.date,
  description: node.frontmatter.description || node.excerpt,
  title: node.frontmatter.title,
  cover: node.frontmatter.featured_image.childImageSharp.gatsbyImageData,
  category: node.frontmatter.categories[0],
});

class BlogPost extends Component {
  render() {
    const post = formatPost(this.props.data.post);
    const similar = this.props.data.similar.edges.map(formatPosts);

    return (
      <>
        <SEO
          title={post.title}
          description={post.description}
          ogType="article"
          ogImage={post.cover.src}
          ogDescription={post.description}
        />

        <Layout blog>
          <MainSection
            title={post.title}
            title_post={post.title_post}
            description={post.description}
            category={post.category}
            featuredImage={post.cover}
          />
          <PostContentSection pageContext={post} location={this.props.location.href}>
            <div dangerouslySetInnerHTML={{ __html: post.html }} />
          </PostContentSection>
          <LikePosts similarPosts={similar} />
        </Layout>
      </>
    );
  }
}

export const query = graphql`
  query Post($slug: String!, $category: [String]) {
    post: markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        categories
        date(locale: "pt-BR", formatString: "LL")
        update_date(locale: "pt-BR", formatString: "LL")
        title
        title_post
        description
        featured_image {
          childImageSharp {
            gatsbyImageData(width: 800)
          }
        }
      }
      excerpt
    }
    similar: allMarkdownRemark(
      sort: { frontmatter: { date: DESC } }
      filter: { frontmatter: { categories: { in: $category } } }
      skip: 1
      limit: 3
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            categories
            date(locale: "pt-BR", formatString: "LL")
            title
            title_post
            description
            featured_image {
              childImageSharp {
                gatsbyImageData(width: 800)
              }
            }
          }
          excerpt
        }
      }
    }
  }
`;

export default BlogPost;
